import gdprCookies from '@reolink-web/gdpr-cookies';
import { config } from 'CONFIG';
import store from '@/store';
import { getCookie } from '@/common/js/utils';
import { isEuropeCountry } from '@/utils/business';
interface IGeo { country: string; region: string; }

function parseGeoCookie(): IGeo | null {

    try {

        const value = getCookie( 'reo_geo' );
        if ( !value ) return null;
        let decoded: string;
        try {

            decoded = decodeURIComponent( value );

        } catch {

            decoded = value;

        }
        const parsed = JSON.parse( decoded );
        if ( typeof parsed.country === 'string' && parsed.country ) {

            return { country: parsed.country, region: typeof parsed.region === 'string' ? parsed.region : '' };
        
        }
        return null;
    
    } catch {

        return null;

    }

}

const hasGdprInstance = (): boolean => JSON.stringify( store.state.user.gpdrObject ) !== '{}';

const shouldShowGdpr = ( country?: string, region?: string ): boolean => {

    if ( getCookie( 'REO_DISABLE_COOKIE' ) !== null ) {

        return false;

    }

    if ( config.platform !== 'web' || !country ) {

        return false;

    }

    if ( country.toUpperCase() === 'US' ) {

        return region?.toUpperCase() === 'CA';
    
    }
    return gdprCookies.isEurap( country );

};

const initGdpr = ( country: string, locale: string ): boolean => {

    const geo = parseGeoCookie();
    const effectiveCountry = geo?.country || country;
    const effectiveRegion = geo?.region || undefined;

    if ( !shouldShowGdpr( effectiveCountry, effectiveRegion ) || hasGdprInstance()) {

        return false;

    }

    gdprCookies.init( effectiveCountry.toUpperCase(), locale, true );
    store.commit( 'GDPRINSTANCE', gdprCookies );
    return true;

};

export const ensureGdprCookiesByCountry = ( country?: string, locale = store.state.lang.lang ): boolean => {

    return country ? initGdpr( country, locale ) : false;

};

export const ensureGdprCookies = ( locale = store.state.lang.lang ): Promise<boolean> => {

    return Promise.resolve( initGdpr( store.getters.country, locale ));

};

export const isGdprRequired = (): boolean => {

    const geo = parseGeoCookie();
    return shouldShowGdpr( geo?.country, geo?.region );

};

export const getFooterCookieLinkVisibility = (): { showCookiePolicy: boolean; showDoNotSellOrShare: boolean; } => {

    const geo = parseGeoCookie();
    const country = ( store.getters.country || geo?.country )?.toUpperCase();
    const isUsCalifornia = country === 'US' && geo?.region?.toUpperCase() === 'CA';
    return {
        showCookiePolicy: isEuropeCountry( country ) || isUsCalifornia,
        showDoNotSellOrShare: isUsCalifornia
    };

};
